import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.weak-map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { SparseMatrix } from 'mathjs';
import { appendColumns, getColumn } from 'utils/ExpressionMatrix/sparseMatrixOperations';
import SparseMap from 'utils/SparseMap';
var densify = function densify(result) {
  if (typeof result === 'number') return [result];
  if (_isNil(result) || _isEmpty(result)) return result;
  return result.valueOf().flat();
};
var toSparseMap = function toSparseMap(cellIndexes, result, keyAsString) {
  if (_isNil(result) || _isEmpty(result)) return new SparseMap([]);
  if (typeof result === 'number') return new SparseMap([[cellIndexes[0], result]]);
  return new SparseMap(result, cellIndexes, keyAsString);
};
var _generateIndexFor = /*#__PURE__*/new WeakMap();
var _getRawColumn = /*#__PURE__*/new WeakMap();
var ExpressionMatrix = /*#__PURE__*/function () {
  function ExpressionMatrix() {
    var _this = this;
    _classCallCheck(this, ExpressionMatrix);
    _defineProperty(this, "setGeneExpression", function (orderedNewGeneSymbols, newRawGeneExpression, newStats) {
      _this.rawGeneExpressions = newRawGeneExpression;
      _this.stats = newStats;
      _this.geneIndexes = orderedNewGeneSymbols.reduce(function (acum, currentSymbol, index) {
        // eslint-disable-next-line no-param-reassign
        acum[currentSymbol] = index;
        return acum;
      }, {});
    });
    _classPrivateFieldInitSpec(this, _generateIndexFor, function (geneSymbol) {
      var lastFreeIndex = Object.keys(_this.geneIndexes).length;
      _this.geneIndexes[geneSymbol] = lastFreeIndex;
      return lastFreeIndex;
    });
    _classPrivateFieldInitSpec(this, _getRawColumn, function (geneSymbol, cellIndexes) {
      var geneIndex = _this.geneIndexes[geneSymbol];
      if (_isNil(geneIndex)) return undefined;
      if ((cellIndexes === null || cellIndexes === void 0 ? void 0 : cellIndexes.length) === 0) return [];
      return getColumn(geneIndex, _this.rawGeneExpressions, cellIndexes);
    });
    this.geneIndexes = {};
    this.rawGeneExpressions = new SparseMatrix();
    this.stats = {
      rawMean: [],
      rawStdev: [],
      truncatedMin: [],
      truncatedMax: []
    };
  }
  _createClass(ExpressionMatrix, [{
    key: "getRawExpression",
    value: function getRawExpression(geneSymbol) {
      var cellIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return densify(_classPrivateFieldGet(_getRawColumn, this).call(this, geneSymbol, cellIndexes));
    }
  }, {
    key: "getTruncatedExpression",
    value: function getTruncatedExpression(geneSymbol) {
      var cellIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var raw = this.getRawExpression(geneSymbol, cellIndexes);
      if (_isNil(raw) || _isEmpty(raw)) return raw;
      var _this$getStats = this.getStats(geneSymbol),
        truncatedMax = _this$getStats.truncatedMax;
      return raw.map(function (v) {
        return Math.min(v, truncatedMax);
      });
    }
  }, {
    key: "getZScore",
    value: function getZScore(geneSymbol) {
      var cellIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var raw = this.getRawExpression(geneSymbol, cellIndexes);
      if (_isNil(raw) || _isEmpty(raw)) return raw;
      var _this$getStats2 = this.getStats(geneSymbol),
        rawMean = _this$getStats2.rawMean,
        rawStdev = _this$getStats2.rawStdev;
      if (rawStdev === 0) return raw.map(function () {
        return 0;
      });
      return raw.map(function (v) {
        return (v - rawMean) / rawStdev;
      });
    }
  }, {
    key: "getRawExpressionSparse",
    value: function getRawExpressionSparse(geneSymbol, cellIndexes) {
      var keyAsString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return toSparseMap(cellIndexes, _classPrivateFieldGet(_getRawColumn, this).call(this, geneSymbol, cellIndexes), keyAsString);
    }
  }, {
    key: "getTruncatedExpressionSparse",
    value: function getTruncatedExpressionSparse(geneSymbol, cellIndexes) {
      var keyAsString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var result = this.getRawExpressionSparse(geneSymbol, cellIndexes, keyAsString);
      if (result.size === 0) return result;
      var _this$getStats3 = this.getStats(geneSymbol),
        truncatedMax = _this$getStats3.truncatedMax;
      // Math.min(0, truncatedMax) === 0 since truncatedMax >= 0, so the
      // sparsified value stays 0 — only stored non-zero values are clamped.
      result.applyModifier(function (v) {
        return Math.min(v, truncatedMax);
      });
      return result;
    }

    // A z-score is an affine transform, so it can ride through the sparse structure the same
    // way truncation does.
  }, {
    key: "getZScoreSparse",
    value: function getZScoreSparse(geneSymbol, cellIndexes) {
      var keyAsString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!(cellIndexes !== null && cellIndexes !== void 0 && cellIndexes.length)) return new SparseMap([]);
      var result = this.getRawExpressionSparse(geneSymbol, cellIndexes, keyAsString);
      if (result.size === 0) return result;
      var _this$getStats4 = this.getStats(geneSymbol),
        rawMean = _this$getStats4.rawMean,
        rawStdev = _this$getStats4.rawStdev;
      if (rawStdev === 0) result.applyModifier(function () {
        return 0;
      });else result.applyModifier(function (v) {
        return (v - rawMean) / rawStdev;
      });
      return result;
    }
  }, {
    key: "getStats",
    value: function getStats(geneSymbol) {
      var geneIndex = this.geneIndexes[geneSymbol];
      if (_isNil(geneIndex)) return undefined;
      return {
        rawMean: this.stats.rawMean[geneIndex],
        rawStdev: this.stats.rawStdev[geneIndex],
        truncatedMin: this.stats.truncatedMin[geneIndex],
        truncatedMax: this.stats.truncatedMax[geneIndex]
      };
    }
  }, {
    key: "geneIsLoaded",
    value: function geneIsLoaded(geneSymbol) {
      return !_isNil(this.geneIndexes[geneSymbol]);
    }
  }, {
    key: "genesAreLoaded",
    value: function genesAreLoaded(geneSymbols) {
      var _this2 = this;
      return geneSymbols.every(function (geneSymbol) {
        return _this2.geneIsLoaded(geneSymbol);
      });
    }
  }, {
    key: "getStoredGenes",
    value: function getStoredGenes() {
      return Object.keys(this.geneIndexes);
    }
  }, {
    key: "pushGeneExpression",
    value: function pushGeneExpression(orderedNewGeneSymbols, newRawGeneExpression, newStats) {
      var _this3 = this;
      var _this$rawGeneExpressi = this.rawGeneExpressions.size(),
        _this$rawGeneExpressi2 = _slicedToArray(_this$rawGeneExpressi, 2),
        genesCount = _this$rawGeneExpressi2[1];
      if (genesCount === 0) {
        this.setGeneExpression(orderedNewGeneSymbols, newRawGeneExpression, newStats);
        return;
      }
      var genesToAddIndexes = [];

      // Store indexes for the new genes
      orderedNewGeneSymbols.forEach(function (geneSymbol, index) {
        // Skip if gene is already loaded
        if (_this3.geneIsLoaded(geneSymbol)) return;
        genesToAddIndexes.push(index);
        _classPrivateFieldGet(_generateIndexFor, _this3).call(_this3, geneSymbol);
      });
      appendColumns(this.rawGeneExpressions, newRawGeneExpression, genesToAddIndexes);
      genesToAddIndexes.forEach(function (index) {
        _this3.stats.rawMean.push(newStats.rawMean[index]);
        _this3.stats.rawStdev.push(newStats.rawStdev[index]);
        _this3.stats.truncatedMin.push(newStats.truncatedMin[index]);
        _this3.stats.truncatedMax.push(newStats.truncatedMax[index]);
      });
    }
  }]);
  return ExpressionMatrix;
}();
export default ExpressionMatrix;